import { render, staticRenderFns } from "./TheHeaderSpaceMenu.vue?vue&type=template&id=17d88f50"
import script from "./TheHeaderSpaceMenu.vue?vue&type=script&lang=js"
export * from "./TheHeaderSpaceMenu.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderSpaceMenu.vue?vue&type=style&index=0&id=17d88f50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports